import axios from "axios";
import { HEADERS } from "../UrlAndPaths";
import { errorSnackMsg, successSnackMsg } from "../../component/Custom Hooks/SnackkBarUtilities";

/**
 * Request OTP for forgot password
 */
export const requestForgotPasswordOTPAPI = async (body) => {
  try {
    const res = await axios.post("admin/requestforgotpasswordotp", body, HEADERS);
    if (res.status === 200) {
      successSnackMsg("OTP sent to your registered email");
      return res.data;
    }
  } catch (err) {
    let message = "Failed to send OTP";
    if (err.response?.status === 422) {
      message = err.response?.data?.data?.msg || "No email registered for this account";
    } else if (err.response?.status === 404) {
      message = "User not found";
    } else if (err.response?.status === 500) {
      message = "Server error";
    }
    errorSnackMsg(message);
    throw new Error(message);
  }
};

/**
 * Verify OTP for forgot password
 */
export const verifyForgotPasswordOTPAPI = async (body) => {
  try {
    const res = await axios.post("admin/verifyforgotpasswordotp", body, HEADERS);
    if (res.status === 200) {
      return res.data;
    }
  } catch (err) {
    let message = "Invalid or expired OTP";
    if (err.response?.status === 403) {
      message = err.response?.data?.data?.msg || "Invalid or expired OTP";
    } else if (err.response?.status === 404) {
      message = "User not found";
    } else if (err.response?.status === 500) {
      message = "Server error";
    }
    errorSnackMsg(message);
    throw new Error(message);
  }
};

/**
 * Reset password with OTP
 */
export const resetPasswordWithOTPAPI = async (body) => {
  try {
    const res = await axios.post("admin/resetpasswordwithotp", body, HEADERS);
    if (res.status === 200) {
      successSnackMsg("Password reset successfully! Please login with your new password.");
      return res.data;
    }
  } catch (err) {
    let message = "Failed to reset password";
    if (err.response?.status === 403) {
      message = err.response?.data?.data?.msg || "Invalid or expired OTP";
    } else if (err.response?.status === 404) {
      message = "User not found";
    } else if (err.response?.status === 500) {
      message = "Server error";
    }
    errorSnackMsg(message);
    throw new Error(message);
  }
};
